import {
    createRouter,
    createWebHistory,
    RouteLocationNormalized,
    RouteRecordRaw,
} from 'vue-router';
import { getBaseUrl } from '@/api/endpoints';
import { loadLanguageAsync } from './localization';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';
import { getTripPlannerUrl } from '@/helpers/url';
import { updateCurrentSessionCart } from '@/api/Cart/cart.helpers';

const GOTO_TRIP_PLANNER_WITH_RECIPE = 'goto-plan-recipe';

const routes: RouteRecordRaw[] = [
    {
        path: '/flight',
        name: 'flight',
        component: () => import('./views/MetaFlightPage.vue'),
    },
    {
        path: '/redirecting',
        name: 'redirecting',
        component: () => import('./views/RedirectPage.vue'),
    },
    {
        path: '/booking',
        name: 'booking',
        component: () => import('./views/MyBookingPage.vue'),
    },
    {
        path: '/bookings',
        name: 'bookings',
        component: () => import('./views/MyBookingsPage.vue'),
    },
    {
        path: '/pre-checkout',
        name: 'pre-checkout',
        component: () => import('./views/PreCheckoutPage.vue'),
    },
    {
        path: '/post-checkout',
        name: 'post-checkout',
        component: () => import('./views/PostCheckoutPage.vue'),
    },
    {
        path: '/checkout',
        name: 'checkout',
        component: () => import('./views/CheckoutPage.vue'),
    },
    {
        path: '/payment',
        name: 'payment',
        component: () => import('./views/PaymentPage.vue'),
    },
    {
        path: '/goto-checkout',
        name: 'goto-checkout',
        component: () => {},
        beforeEnter: () => {
            window.location.href = getOldCheckoutUrl();
        },
    },
    {
        path: '/goto-plan',
        name: 'goto-plan',
        component: () => {},
        beforeEnter: () => {
            window.location.href = getTripPlannerUrl();
        },
    },
    {
        path: '/goto-plan-recipe',
        name: GOTO_TRIP_PLANNER_WITH_RECIPE,
        component: () => {},
        beforeEnter: (to: RouteLocationNormalized) => {
            const plannerUrl = getTripPlannerUrl();
            const url = `${plannerUrl}?recipe=${to.query['recipe']}`;
            window.open(url, '_target');
        },
    },
];

const router = createRouter({
    history: createWebHistory('/travel'),
    routes,
});

function getOldCheckoutUrl(): string {
    const baseUrl = getBaseUrl();
    return `${baseUrl}booking/checkout.aspx`;
}

router.beforeEach(async (to, from, next) => {
    const locale = getCurrentMarketSpecs().locale;
    await loadLanguageAsync(locale);
    if (from?.name === 'checkout') {
        updateCurrentSessionCart();
    }
    next();
});

export default router;
